import { Box } from "@mui/material";
import Home from "./Home";

export function UserManagement() {
  const user_role = localStorage.getItem('role');
  return (
    <Box sx={{ p: 0 }}>
      <Home hideFooter={user_role !== 'user'} />
    </Box>
  );
}